import { Ref } from 'vue'

export enum StoreRequestStatus {
  idle, loading, succeeded, failed
}

export interface StoreWithRequest {
  status: Readonly<Ref<StoreRequestStatus>>
  fetch: () => Promise<void>
}
